module.exports = __webpack_public_path__ + "img/coolant-temp-warm.c8956ee8.svg";